import { saveAs } from "file-saver";
import { useContext, useEffect, useState } from "react";
import { MdDownload, MdEdit, MdLock, MdLockOpen, MdPrint, MdSearch } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { utils, write } from "xlsx";
import Modal from "../../Components/Modal";
import NoProfileImage from "../../Components/NoProfileImage";
import Spinner from "../../Components/Spinner";
import Warning from "../../Components/Warning";
import UserContext from "../../Context/UserContext";
import { disableUserAccount, getEventsDoc, getUsersDoc } from "../../Requests/firebaseFirestore";
import { printExhTag } from "../../Requests/printTag";
import { updateUserDoc } from "../../Requests/firebaseFirestore";

export default function UsersPage(){
  const [users, setUsers] = useState([])
  const [userList, setUserList] = useState([])
  const [search, setSearch] = useState({name:'', event:'', role:''})
  const {role} = useParams()
  const [events, setEvents] = useState([])
  const navigate =useNavigate()
  const {user} = useContext(UserContext)
  const [templateUrl, setTemplateUrl] = useState('')
  const [templateWarning, setTemplateWarning] = useState(false)
  const [forcePrintModal, setForcePrintmodal] = useState(false)
  const [scannedExh, setScannedExh] = useState({})
  const [tagModal, setTagModal] = useState(false)
  const [templateError, setTemplateError] = useState('')
  const [loading, setLoading] = useState(true)
  const [position, setPosition] = useState('')
  const [editUserModal, setEditUserModal] = useState(false)
  const [userToEdit, setUserToEdit] = useState({})

  const handleEditUserModal = (usr) => {
    if(usr){setUserToEdit(usr)}
    setEditUserModal(!editUserModal)
    console.log(usr)
  }

  const reloadUserList = async (users) => {
    setLoading(true)
    if(users){
      setUserList([...users])
    }else{
      const res = await getUsersDoc();
      setUsers(res)
      setUserList(res)
    }
    setLoading(false)
  }
  const getEvents = async() => {
    const res = await getEventsDoc()
    setEvents([...res])
  }

  useEffect(()=>{
    if(role!=='organizer'||user.role!=='organizer'){
      navigate(`/${user.role}`)
    }else{
      getEvents()
    }
    reloadUserList()
  },[user, navigate, role])

  const handleForcePrintModal = async (usr) => {
    setForcePrintmodal(!forcePrintModal)
    setTemplateError('')
    if(usr){
      console.log(usr)
      setScannedExh(usr)
      setPosition(usr.position|| '')
    }
    else{
      setScannedExh({})
    }
  }

  const printTag = async () => {
    console.log(templateUrl, scannedExh)
    
    if(templateUrl){
      const res = await printExhTag(scannedExh, templateUrl)
      if(res === 'error'){
        setTemplateError("No se pudo imprimir la etiqueta")
      }else{
        setTemplateError('')
        setForcePrintmodal(false)
      }
    }else{
      setTemplateError('')
      setForcePrintmodal(false)
      setTemplateWarning(true)
    }
    
  }

  const handleTemplateWarning = () => {
    setTemplateWarning(!templateWarning)
  }

  const handleTagModal = () => {
    setTagModal(!tagModal)
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    let filteredList = []
    users.forEach((user)=>{
      let evnts = []
      switch (user.role) {
        case 'exhibitor':
          evnts = user.events.map(evnt=>evnt.id)
          break;
        case 'staff':
          evnts = [user.event.id]
          break;
        default:
          evnts = []
          break;
      }

      if((user.company.toLowerCase().includes(search.name.toLowerCase())||user.fullName.toLowerCase().includes(search.name.toLowerCase()))&&(evnts.includes(search.event)||search.event==='')&&(user.role === search.role || search.role==="")){
        filteredList = [...filteredList, user]
      }
    })
    reloadUserList(filteredList)
  }

  useEffect(()=>{
    const cookies =new Cookies()
    if(cookies.get('exhTagTemplateUrl')){
      setTemplateUrl(cookies.get('exhTagTemplateUrl'))
    }
  },[])

  const handleTemplateSubmit = (e) => {
    e.preventDefault()
    const cookies = new Cookies()
    cookies.set('exhTagTemplateUrl', templateUrl, {path: '/'})
    handleTagModal()
  }

  const handleDisable = async (id, state) =>{
    await disableUserAccount(id, state)
    reloadUserList()
  }

  const handleDownload = () => {
    let toXls = []
    userList.forEach((user)=>{
      let events = []
      user.events.forEach((event)=>{
        events = [...events, event.name]
      })
      toXls = [...toXls, {'Nombre':user.fullName, 'Empresa':user.company, 'Email':user.email, 'Rol':user.role, 'Eventos':events.join(', ')}]
    })
    
    const ws = utils.json_to_sheet(toXls)
    const wb = {
      Sheets:{
        'data':ws
      },
      SheetNames:['data']
    }
    const eb = write(wb,{bookType:'xlsx',type:'array'})
    const data = new Blob([eb],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UFT-8'})
    saveAs(data, 'ChannelTalks-usuarios.xlsx')
  }
  
  const canDisable = (usr) =>{
    let res

    if(usr.id===user.uid||(usr.type==='superAdmin'&&user.type!=='superAdmin')){
      res = true
    }
    return res
  }


  const handleEditUserInput = (e) => {
    const {name, value} = e.target
    setUserToEdit({...userToEdit, [name]:value})
  }

  const handleEditUserSubmit = async (e) => {
    e.preventDefault()
    await updateUserDoc(userToEdit.uid, {company:userToEdit.company, fullName: userToEdit.fullName, position: userToEdit.position})
    console.log(userList.findIndex(u=>u.uid===userToEdit.uid))
    let list = userList
    list[userList.findIndex(u=>u.uid===userToEdit.uid)] = userToEdit
    setUserList([...list])
    list = users
    list[users.findIndex(u=>u.uid===userToEdit.uid)] = userToEdit
    setUsers([...list])
    handleEditUserModal()
  }


  return(<>
  {loading?
  <div className="text-black py-5">
  <Spinner/>
</div>
:
    <div className="container mx-auto px-4">
      <div className="flex justify-between my-4">
      <h1 className="text-stone-600 font-semibold text-xl py-2">Usuarios</h1>
      {role==='organizer'?
      <button onClick={handleTagModal} className='action-btn relative'>Configurar etiqueta
      {templateUrl?<></>:
      <>
      <span className="absolute rounded-full  h-5 w-5 bg-red-400 -top-1 -right-1 flex justify-center items-center">
      <span className="absolute rounded-full h-4 w-4 animate-ping bg-red-400"></span>
        </span>
      </>}
        </button>
      :<></>}
      </div>

      <div className="table-holder">
      <table className="table-auto min-w-[600px]">
        <thead>
          <tr>
            <th colSpan='100%'>
              <div className="px-5 w-full flex items-center justify-between">
                <form onSubmit={handleSearchSubmit} className='flex flex-row gap-2'>
                  <input type="text" id="search" className=" font-normal text-black" placeholder="Nombre o empresa" onChange={(e)=>{setSearch({...search, name:e.target.value})}} value={search.name}/>
                  <select name="" id="" className=" font-normal text-black" value={search.event} onChange={(e)=>{setSearch({...search, event:e.target.value})}}>
                    <option value="" >Todos los eventos</option>
                    {events.map((event, index)=>{return(
                      <option value={event.id} key={index}>{event.name}</option>
                    )})}
                  </select>
                  <select name="" id="" className=" font-normal text-black" value={search.role} onChange={(e)=>{setSearch({...search, role:e.target.value})}}>
                    <option value="" >Todos los roles</option>
                      <option value='organizer'>Organizador</option>
                      <option value='exhibitor'>Expositor</option>
                      <option value='staff'>Staff</option>
                  </select>
                  <button className="light-button"><MdSearch size={25}/></button>
                </form>
                <button className="light-button flex gap-1" onClick={handleDownload}>
                <MdDownload size={25}/>Descargar
              </button>
              </div>
            </th>
          </tr>
          <tr>
            <th>Acciones</th>
            <th>Nombre completo</th>
            <th>Empresa</th>
            <th>Email</th>
            <th>Imagen</th>
            <th>Rol</th>
            <th>Eventos</th>
          </tr>
        </thead>
        <tbody>
          {userList.length===0?
          <tr>
            <td colSpan='100%'>
              <h1>No se encontraron usuarios</h1>
            </td>
          </tr>
          :<>
            {userList.map((usr, index)=>{
              return(<tr key={index}>
                <td>
                  <div className="flex justify-center items-center gap-1">

                    {
                      usr.role!=='organizer'?
                      <>
                        <button className="action-button border-amber-500 text-amber-500 hover:text-white hover:bg-amber-500 active:bg-amber-700 duration-150" onClick={()=>{handleEditUserModal(usr)}}><MdEdit size={25}/></button>
                        <button className="action-button border-blue-500 text-blue-500 hover:text-white hover:bg-blue-500 active:bg-blue-700 duration-150" onClick={()=>{handleForcePrintModal(usr)}}><MdPrint size={25}/></button>
                      </>
                      :<></>
                    }
                    <button className="action-button border-stone-500 text-stone-500 hover:text-white hover:bg-stone-500 active:bg-stone-700 duration-150" disabled={canDisable(usr)} onClick={()=>{handleDisable(usr.id, usr.inactive)}}>{usr.inactive?<MdLock size={25}/>:<MdLockOpen size={25}/>}</button>
                  </div>
              </td>
              <td>{usr.fullName} {usr.inactive?' (Inactivo)':''}</td>
                <td>{usr.company}</td>
                <td>{usr.email}</td>
                <td>{usr.imageUrl?
                <img src={usr.imageUrl} alt={usr.company} className='w-[50px] rounded-[50%] mx-auto'/>:
                <NoProfileImage size={50}/>
                }</td>
                <td>{usr.role}</td>
                <td >{usr.role==='organizer'?<>-</>:<></>}
                {usr.role==='exhibitor'?<div className="flex flex-col">
                {usr.events.map((event, index) => {
                  return(<span key={index} className='px-1'>{event.name}</span>)
                })}</div>:<></>}
                {usr.role==='staff'?<>{usr.event.name}</>:<></>}
                </td>
              </tr>)
            })}
          </>}
        </tbody>
      </table>
      </div>
      <Modal isActive={forcePrintModal} handle={handleForcePrintModal} title={"Imprimir etiqueta de expositor"}>
        <div className="mx-auto w-[75%] bg-stone-100 rounded-[10px] py-2 px-3 mb-2">
          <h1 className="font-semibold text-xl flex items-center">Expositor: 
          </h1>
          <div className="pl-4 divide-y-2 flex flex-col">
            <div className="flex flex-row justify-around py-2">
              <span className="text-left flex-1">Nombre:</span> <span className="flex-1">{scannedExh.fullName}</span>
            </div>
            <div className="flex flex-row justify-around py-2">
              <span className="text-left flex-1">Empresa:</span> <span className="flex-1">{scannedExh.company}</span>
            </div>
            <div className="flex flex-row justify-around py-2">
              <span className="text-left flex-1">Cargo:</span>
              {position?
              <span className="flex-1">{position}</span>
              :
              <span className="flex-1 text-red-400">No se especificó</span>
              }
            </div>
          </div>
        </div>
            {position?<></>:
              <div className="input-holder w-[60%] my-4">
                <input type="text" id="scanned-exh-position" onChange={(e)=>{setScannedExh({...scannedExh, position:e.target.value})}}/>
                <label htmlFor="scanned-exh-position">Indicar cargo</label>
              </div>
            }
        {templateError!==""?<h1 className="text-center pb-2 my-3">{templateError}</h1>:<></>}
        <div className="flex justify-center w-[75%] mx-auto">
          {
            scannedExh.position?
            <button className="send-btn " onClick={()=>{printTag()}}>Imprimir etiqueta</button>
            :
            <button className="send-btn " disabled>Imprimir etiqueta</button>
          }
        </div>
      </Modal>
      <Warning isActive={templateWarning} handle={handleTemplateWarning} title="No se especificó un archivo para las etiquetas">
      </Warning>
      <Modal isActive={tagModal} handle={handleTagModal} title={"Configurar etiqueta"}>
      <div className="flex flex-col gap-4">
          {templateUrl?<></>:
          <span className="w-[75%] mx-auto text-center">No se especificó ningún archivo para las etiquetas</span>}
      <a 
      href="https://firebasestorage.googleapis.com/v0/b/channel-talks-web.appspot.com/o/defaultFiles%2FExpositores.lbx?alt=media&token=662808f8-0575-4fe5-bc6b-3a59a83aaa92"
      download='template.blx'
      className="action-btn mx-auto">
        descargar archivo .lbx
      </a>
      <form className="flex flex-col gap-4 justify-center" onSubmit={handleTemplateSubmit}>
      <div className="input-holder w-[50%]">
        <input type="text" id="tag-template-path" onChange={(e)=>{setTemplateUrl(e.target.value)}} value={templateUrl} required/>
        <label htmlFor="tag-template-path">Direccion de archivo</label>
      </div>
          <button className="send-btn">Guardar</button>
      </form>
        </div>
      </Modal>
      <Modal isActive={editUserModal} handle={()=>{handleEditUserModal()}} title={'Editar usuario'}>
          <form className="flex flex-col gap-2" onSubmit={handleEditUserSubmit}>
            <div className="input-holder w-[70%]">
              <input type="text" value={userToEdit.fullName} name={'fullName'} onChange={handleEditUserInput} required/>
              <label htmlFor="">Nombre</label>
            </div>
            <div className="input-holder w-[70%]">
              <input type="text" value={userToEdit.company} name={'company'} onChange={handleEditUserInput} required/>
              <label htmlFor="">Empresa</label>
            </div>
            <div className="input-holder w-[70%]">
              <input type="text" value={userToEdit.position} name={'position'} onChange={handleEditUserInput} required/>
              <label htmlFor="">Cargo</label>
            </div>
            <button className="send-btn ">Aceptar</button>
          </form>
      </Modal>
    </div>
  }
  </>
  )
}